export default __webpack_public_path__ + "static/media/facebook.11c26c0e.svg";